export default "__VITE_PUBLIC_ASSET__decf66a1__"